import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../../../../settings/index';
import Api from '../../../../../../../helpers/api';
import { sendRequest } from '../../../../../../../helpers/saga';
import { logger } from '../../../../../../../helpers/logger';
import notifications from '../../../../../../../redux/notifications/actions';

const jobsApi = new Api('clients/:id/invoices/:id/non_activated_jobs');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id } = payload;
    const result = yield call(
      sendRequest,
      jobsApi.load,
      { search: { page, pageSize, column, order, filter }, id },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      const { data, totalCount, filteredCount, sortable_columns } = result.data;

      yield put(
        actions.loadDataSuccess({
          data,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
